export default "__VITE_ASSET__Bidj9WJ2__"